import { render, staticRenderFns } from "./SettingField.vue?vue&type=template&id=b11c4540&scoped=true"
import script from "./SettingField.vue?vue&type=script&lang=js"
export * from "./SettingField.vue?vue&type=script&lang=js"
import style0 from "./SettingField.vue?vue&type=style&index=0&id=b11c4540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11c4540",
  null
  
)

export default component.exports